// components/GanttView.js
import { useCallback, useEffect, useRef, useState } from 'react';
import { gantt } from '@dhx/trial-gantt';
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';
import '../../assets/gant/dhtmlxgantt.css';
import AddEditTask from './new-task-popup';
import AssignUserAtDate from './assing-user-at-date';
import AddEditCategory from './new-category-popup';
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { useRouter } from 'src/routes/hooks';
import Iconify from '../iconify';
import Label from '../label';
import { USER_STATUS_OPTIONS } from 'src/_mock';
import { defaultConfigureGantt } from './components/gantt-configs/GanttConfigDefault';
import { configureZoom } from './components/GanttZoom';
import { configureLightbox } from './components/GanttLightbox';
import { histogramConfigureGantt } from './components/gantt-configs/GanttConfigHistogram';
import { assignResourcesConfigureGantt } from './components/gantt-configs/GanttConfigAssignResources';
import { useNavigate } from 'react-router';
import { generateColumns } from './components/GanttColumns';
import { useData } from '../../contexts/gantt-chart/gantt-context';
export default function GanttViewAssignHours({ gantt_resources, reload,assignHours }) {
  const {defaultVisibleColumn,handleColumnChange} = useData();
  const router = useRouter();
  const container = useRef();
  const [categoryModal, setCategoryModal] = useState(false);
  const [taskModal, setTaskModal] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [resourceView, setResourceView] = useState('week');
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorColsEl, setAnchorColsEl] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState(defaultVisibleColumn);
  useEffect(() => {
    if (defaultVisibleColumn) {
      delete defaultVisibleColumn.add;
      setVisibleColumns(defaultVisibleColumn);
    }
  }, [defaultVisibleColumn]);
  useEffect(() => {
    gantt.plugins({ wbs: true, resource: true });
    gantt.config.drag_mode = false;
    gantt.config.drag_mode = {
      row: false, 
      task: false,   
      progress: false 
    };
    const currentColumns = gantt.config.columns || [];
    const ownerColumn = currentColumns.find((col) => col.label === 'Owner');
    const newColumns = generateColumns(visibleColumns, gantt);
    if (ownerColumn) {
      newColumns.splice(2, 0, ownerColumn);
    }
    
    gantt.config.columns = newColumns;
    gantt.config.resource_render = 'tree';
    // gantt.config.duration_unit = "day";
    // gantt.config.work_time = true;
    // gantt.config.correct_work_time = true;
    // gantt.templates.timeline_cell_class = function (task, date) {
    //   if (!gantt.isWorkTime({date: date, task: task}))
    //     return "weekend-highlight";
    //   return "";
    // };
    assignResourcesConfigureGantt(gantt, () => generateColumns(visibleColumns, gantt),assignHours);
    gantt.attachEvent('onScaleClick', function (e, date) {
      setSelectedDate(date);
      setAssignModal(true);
    });
    gantt.showLightbox = (id) => {
      const task = gantt.getTask(id);
      console.log(task, 'clicked task');
      gantt.deleteTask(id);
     return false
    };
    gantt.hideLightbox = () => {
      return false
    };
    configureZoom(gantt, resourceView);
    gantt.init(container.current);
    if (gantt_resources) {
      gantt.parse(gantt_resources);
    }
    return () => {
      gantt.clearAll();
    };
  }, []);

  useEffect(() => {
    const currentColumns = gantt.config.columns || [];
    const ownerColumn = currentColumns.find((col) => col.label === 'Owner');
    const newColumns = generateColumns(visibleColumns, gantt);
    
    // Insert ownerColumn at position 3 (index 2)
    if (ownerColumn) {
      newColumns.splice(2, 0, ownerColumn);
    }
    
    gantt.config.columns = newColumns;
    gantt.render();
  }, [visibleColumns]);

  const handleCloseCategoryModal = () => {
    setCategoryModal(false);
    setSelectedTask(null);
  };

  const handleCloseTaskModal = () => {
    setTaskModal(false);
    setSelectedTask(null);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleColsMenuClick = (event) => {
    setAnchorColsEl(event.currentTarget);
  };

  return (
    <>
      <Card
        sx={{
          width: '100%',
          margin: 'auto',
          mt: 4,
          // p: 2,
          borderRadius: '5px',
          // borderLeft:"10px solid #FFBDAD",
          boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 2 }}>
          <Typography variant="h4">Assign Resources</Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <Box
              display="flex"
              alignItems="center"
              onClick={() => (window.location.href = '/gantt-chart')}
            >
              <IconButton
                sx={{ position: 'relative', bottom: '2px' }}
                variant="outline"
                onClick={handleColsMenuClick}
                aria-label="Columns"
              >
                <Iconify
                  icon="material-symbols:keyboard-backspace-rounded"
                  width="24"
                  height="24"
                />
              </IconButton>
              <Typography sx={{ cursor: 'pointer' }} ml={1} fontSize={16}>
                Go Back
              </Typography>
            </Box>
          </Box>
        </Box>

        <Stack sx={{ position: 'relative' }}>
          <Box className="pink-gantt" ref={container} sx={{ width: '100%', height: '800px' }}></Box>
        </Stack>
      </Card>
      <AddEditCategory
        open={categoryModal}
        onClose={handleCloseCategoryModal}
        item={selectedTask}
        reload={reload}
      />
      <AddEditTask open={taskModal} onClose={handleCloseTaskModal} />
{selectedDate &&      <AssignUserAtDate
        gantt={gantt}
        selectedDate={selectedDate}
        open={assignModal}
        onClose={() => setAssignModal(false)}
      />}
    </>
  );
}
